<template>
    <div>
        <Hero></Hero>
        <LeahuAcademy></LeahuAcademy>
       <div class="background">
           <DinticaWorld></DinticaWorld>
           <Games></Games>
           <Yummy></Yummy>
           <BottomCharacters></BottomCharacters>
       </div>
    </div>
</template>

<script>
    import Hero from "./landing/Hero.vue"
    import LeahuAcademy from "./landing/LeahuAcademy.vue"
    import DinticaWorld from "./landing/DinticaWorld.vue"
    import Games from "./landing/Games.vue"
    import Yummy from "./landing/Yummy.vue"
    import BottomCharacters from "./landing/BottomCharacters.vue"

    export default {
        name: "Landing",
        components: {
            Hero,
            LeahuAcademy,
            DinticaWorld,
            Games,
            Yummy,
            BottomCharacters
        },
    }
</script>

<style lang="scss">
    @import "../styles/landing.scss";
    @import "../styles/animations.scss";
</style>
